export default __webpack_public_path__ + "static/media/guesty_lite_step5.e0171c97.png";